/** System prompts sent to the companion when the user toggles screen sharing. */

export const SCREEN_SHARE_COMPANION_MESSAGES = {
  started:
    "The user has just started sharing their screen with you. Briefly acknowledge that you can now see their screen and invite them to point out what they'd like to discuss. Keep it natural and conversational.",
  stopped:
    'The user has just stopped sharing their screen. Briefly acknowledge this and continue the conversation naturally.',
} as const;
